module.exports = __webpack_public_path__ + "img/Background.19d9e663.jpg";